import { Injectable } from '@angular/core';
import { environment } from "../environments/environment";
import { Http, Response, ResponseContentType } from "@angular/http";
import { AuthHttp } from 'angular2-jwt';
import { Observable } from "rxjs/Observable"

import "rxjs/add/operator/map";

@Injectable()
export class FinalBonusApiService {

  constructor(private authHttp: AuthHttp) { }

  GetYearDropdown() {
    return this.authHttp.get(environment.apiEndPoint + '/Bonus/GetYearList')
      .map((response: Response) => response.json())
  }

  GetListBonus(year, quartal, mainDealerID) {
    return this.authHttp.get(environment.apiEndPoint + '/Bonus/' + year + '/' + quartal + '/' + mainDealerID)
      .map((response: Response) => response.json())
  }

  DownloadAllFinalBonus(year, quartal, mainDealerID) {
    return this.authHttp.get(environment.apiEndPoint + '/Bonus/DownloadAll/' + year + '/' + quartal + '/' + mainDealerID, {
      responseType: ResponseContentType.ArrayBuffer
    })
  }

  GetBonusDealer(Id) {
    return this.authHttp.get(environment.apiEndPoint + '/Bonus/GetBonusDealer/' + Id)
      .map((response: Response) => response.json());
  }

  SubmitBonusDealer(bonusData, headers) {
    return this.authHttp.post(environment.apiEndPoint + '/Bonus/Publish', JSON.stringify(bonusData), { headers: headers })
      .map((response : Response) => response.json())
  }
}



// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/data/FinalBonusApi.service.ts